export default "__VITE_ASSET__BoweQQoz__"